import { ResolvePermalinkUrl } from "../functions";

export class UserPrivateAccountView {
  renderHeader(_data) {
    return `
      <div class="user-header">
        <div>
          <h1 class="al"> Confirguración de mi cuenta </h1>
          Publicaciones activas: <span id="publicaciones-activas">---</span>
          <br>
          Banners activos: <span id="banners-activas">---</span>
        </div>
        <div class="ar">
          <h3 id="user-plan-indicator-2">---</h3>
          <button id="user-plan-button" class="locked" onclick="app.userPrivateController.account.subscriptions.showChangePlan()">Editar mi plan</button>
        </div>
      </div>
    `;
  }

  renderForm(_data) {
    if (!_data) {
      _data = {};
    }
    if (_data.imageURL && _data.imageURL.indexOf('/.jpg') > -1) {
      _data.imageURL = '/assets/img/user.jpg';
    }
    if (_data.imageURL === '') {
      _data.imageURL = '/assets/img/user.jpg';
    }
    return `
    <div class="form">
      <div class="group mt20">
        <h2 class="mb0 ancho">Datos de acceso</h2>
        <div class="group">
          <b>Email</b>
          <input type="email" id="account-email" value="${_data.email || ''}"> 
          <span id="account-email-error"></span>
        </div>
        <div class="group">
          <b>Contraseña</b>
          <div class="account-password">
            <input type="password" id="account-password" value="${_data.password || ''}" placeholder="Ingrese su contraseña" />
            <div class="ojo oculto" onclick="app.userPrivateController.auth.loginPasswordVisibility(this)"></div>
          </div>
          <span id="account-password-error"></span>
        </div>
        <div class="col-2">
          <button class="mt20" onclick="app.userPrivateController.account.save()">Actualizar</button>
        </div>
      </div>
      <hr class="hr-full mobile mb0 mt0">
      <div class="group mt20">
        <h2 class="mb0 ancho">Mi perfil</h2>
        <div class="group">
          <b>Enlace permanente a mi perfil</b>
          <div class="permalink-container">
            <input type="text" id="account-permalink"onkeyup="this.value = app.userPrivateController.account.filterPermalinkInput(this.value);" value="${_data.permalink || ''}"/>
            <button class="btn-2" style="padding: 7px 10px; width: 90px; display: block; text-align: center;" onclick="navigator.clipboard.writeText('${ResolvePermalinkUrl(_data.permalink, false)}'); this.innerHTML ='¡Copiado!'; this.classList.add('bg-v22');">Copiar</button>
            <div class="init-link">https://agrolabores.com/perfil/</div>
          </div>
          <div id="account-permalink-status" class="mt10" style="height:0px"></div>
        </div>
        <hr>
        <div class="group">
          <div class="col-1-1">
            <img id="account-image-preview" class="image" src="${_data.imageURL}" onclick="app.userPrivateController.auth.showAvatar()">
            <input type="file" id="account-image" idcod="${_data.image || ''}" accept=".jpg,.jpeg,.png,.webp" onchange="APICRUD.Image.Upload(this, 'account-image-preview')"> 
            <div class="col-2">
              <button class="btn-2 ico-plus" onclick="document.getElementById('account-image').click()">
                <span class="material-symbols-sharp">add</span>
                ${_data.image ? 'Cambiar' : 'Cargar '} imagen
              </button>
            </div>
          </div>
        </div>
        <div class="col-2">
          <button class="mt20" onclick="app.userPrivateController.account.save()">Actualizar mi perfil</button>
          <div id="account-permalink-error" class="mt10" style="height:0px"></div>
        </div>
      </div>
      <hr class="hr-full">
      <h2 class="mb0 ancho">Datos personales</h2>
      <div class="group">
        <b>Nombre</b>
        <input type="text" id="account-name" value="${_data.name || ''}"> 
        <span id="account-name-error"></span>
      </div>
      <div class="group">
        <b>Teléfono</b>
        <input type="tel" id="account-phone" value="${_data.phone || ''}"> 
        <span id="account-phone-error"></span>
      </div>
      <div class="group">
        <b>Organización</b>
        <input type="text" id="account-organization" value="${_data.organization || ''}"> 
        <span id="account-organization-error"></span>
      </div>
      <div class="group">
        <b>Cargo</b>
        <select id="account-occupation" value="${_data.occupation || ''}"> </select>
        <span id="account-occupation-error"></span>
      </div>
      <div class="group">
        <b>Provincia</b>
        <select id="account-idState" value="${_data.idState || ''}" onchange="
        APICRUD.Location.Selector_LoadCities('account-idCity', this.value, '${_data.idCity}')
        "></select>
        <span id="account-idState-error"></span>
      </div>
      <div class="group">
        <b>Localidad</b>
        <select id="account-idCity" value="${_data.idCity || ''}"></select>
        <span id="account-idCity-error"></span>
      </div>
      <div class="col-2">
        <button class="mt20" onclick="app.userPrivateController.account.save()">Guardar mis datos</button>
        <div id="account-status" class="mt20"></div>
      </div>
      <hr class="hr-full">
    </div>

    <button class="mt20 btn-2" onclick="app.userPrivateController.account.closeAccount()" style="padding: 7px 10px; width: 170px; display: block;">Eliminar mi cuenta</button>
    `;
  }

  renderCloseAccount() {
    return `
      <b>¿Está seguro que desea eliminar su cuenta? </b>
      Antención: esta acción no puede deshacerse, por favor lea atentamente la siguiente información.
      <ul>
        <li>Se cancelará la suscripción a su plan. Si estaba suscrito a través de Mercado Pago, cancelaremos su suscripción.</li>
        <li>Sus publicaciones activas, seguirán visibles pero con usuario anónimo. Para evitarlo, puede eliminar sus publicaciones antes de cerrar su cuenta.</li>
      </ul>
      <div class="form">
        <div class="group">
          <b>Ingrese su email para confirmar:</b>
          <input type="email" id="close-account-email-confirm" value=""/>
        </div>
        <div class="group">
          <b>Ingrese la frase <i>"cerrar mi cuenta"</i>:</b>
          <input type="text" id="close-account-phrase-confirm" style="text-transform: uppercase; color: red" value=""/>
        </div>
        <div class="group span">
          <div id="close-account-status" class="ac"></div>
        </div>
      </div>

      <button class="mt20 mb20" onclick="app.userPrivateController.account.modalCloseAccount.close()">Conservar mi cuenta</button>
      <button class="mt20 mb20 fr bg-red" id="close-account-btn" onclick="app.userPrivateController.account.closeAccountConfirmation()">Eliminar mi cuenta</button>
    `;
  }

  renderPublishLimit() {
    return `
      <h2 class="mb0">Ha llegado al límite de publicaciones de su plan.</h2>
      Esta publicación se guardará pero permanecerá oculta.
      <hr>
      <h2 class="mb0">Puede obtener más capacidad desde aquí:</h2>
      <button class="mt20" onclick="app.userPrivateController.account.subscriptions.showChangePlan()">Editar mi plan</button>
    `;
  }

}
